import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ServiceScheduleComponent} from './service-schedule.component';
import {ServiceScheduleRoutingModule} from './service-schedule-routing.module';


@NgModule({
  declarations: [ServiceScheduleComponent],
  imports: [
    CommonModule,
    SharedModule,
    ServiceScheduleRoutingModule,
    DragDropModule
  ]
})
export class ServiceScheduleModule {
}
